import axios from 'axios';

import { APIResponseParsed } from 'types/response';
import { deleteRequest } from 'utils/HttpRequest/http-request-utils';

import { parseAxiosError } from './utils/parse-axios-error';

async function deleteUserMembership(
  userMembershipId: number
): Promise<APIResponseParsed<'OK'>> {
  try {
    await deleteRequest(`user-membership/${userMembershipId}`);
    return { data: 'OK', error: null };
  } catch (error) {
    if (!axios.isAxiosError(error)) throw error;
    return { data: null, error: parseAxiosError(error) };
  }
}

async function deleteUserMemberships(
  userMembershipIds: number[]
): Promise<APIResponseParsed<'OK'>[]> {
  const responses: APIResponseParsed<'OK'>[] = [];

  await Promise.allSettled(
    userMembershipIds.map(
      async (userMembershipId) => {
        const response = await deleteUserMembership(userMembershipId);
        responses.push(response);
      }
    )
  );

  return responses;
}

export default {
  deleteUserMemberships
};